export const FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_REQUEST = "FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_REQUEST";
export const FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_SUCCESS = "FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_SUCCESS";
export const FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_FAILURE = "FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_FAILURE";
